<template>
  <div class="login-success-page">
    <div class="loader-block">
      <h3>{{ $t('Авторизация через ЕСИ...') }}</h3>
      <div class="spinner"></div>
      <p>{{ $t('Пожалуйста, подождите') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginSuccess',
  mounted() {
    const token = this.$route.query.token
    const warning = this.$route.query.warning

    if (token) {
      this.$store.dispatch('setUserToken', {
        token: token,
        user: undefined
      })

      if (warning) {
        this.$noty.info(warning, {
          killer: true,
          timeout: 10000,
          layout: 'topRight'
        })
      } else {
        this.$noty.success(this.$i18n.t('Вы успешно вошли'), {
          killer: true,
          timeout: 3000,
          layout: 'topRight'
        })
      }

      const redirect = sessionStorage.getItem('redirectPath')

      setTimeout(() => {
        if (redirect) {
          sessionStorage.removeItem('redirectPath')
          this.$router.push(redirect)
        } else {
          this.$router.push({ name: 'profile' })
        }
      }, 500)

    } else {
      this.$noty.error(this.$t('Ошибка авторизации'), {
        killer: true,
        timeout: 3000,
        layout: 'topRight'
      })
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
.login-success-page {
  display: flex;
  height: 60vh;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
